import PropTypes from 'prop-types'
import { useEffect } from 'react'
import useOneSignal from 'shared/hooks/useOneSignal'

export default function OneSignalWrapper({ children }) {
  const { initOneSignal } = useOneSignal()
  useEffect(() => {
    initOneSignal()
      .then((isInit) => {
        localStorage.setItem('sPushToken', isInit)
      })
      .catch(console.error)
  }, [])
  return children
}

OneSignalWrapper.propTypes = {
  children: PropTypes.node.isRequired
}
